import {
  useComplements,
  useProduct,
} from '@customink/project-service-react-components';
import type { ProjectItem } from '@customink/project-service-types';

export const useFilteredComplements = (projectItems: ProjectItem[]) => {
  const anchorProjectItem = projectItems[0];
  const { data: anchorProduct } = useProduct({
    colorId: anchorProjectItem.product?.colorId,
  });

  const { data: complementaryProducts } = useComplements({
    styleId: anchorProduct?.id || 0,
    colorId: anchorProjectItem.product?.colorId || 0,
  });

  const projectItemsStyleIds = projectItems.map(
    (item) => item.product?.colorId,
  );

  const filteredComplementaryProducts = complementaryProducts?.filter(
    (product) => !projectItemsStyleIds.includes(product.colorId),
  );

  return filteredComplementaryProducts;
};
